module.exports = __webpack_public_path__ + "static/img/Wsy.58cbff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Wsy.jpg
// module id = QuEP
// module chunks = 1